<script>
    import { createEventDispatcher } from 'svelte';
    import ProviderImage from "./image.svelte";
    import Button from "../../components/button.svelte";
    const dispatch = createEventDispatcher();
    export let isButtonLoading=false;
    export let showChange = false;
    export let provider; 

</script>

<style>
    /* .card{
        min-height:200px;max-height:200px
    } */
    img{
        max-height:100px;max-width:100%;
    }
</style>

<div class="col-md-6">
    <div class="card">
        <div class="card-body">           
            <ProviderImage {provider}/>            
        </div>
        <div class="card-footer">          
            {#if showChange}
            <button class="btn btn-primary" data-toggle="modal"  data-target=".change-mis" on:click="{()=> dispatch("change")}">Change MIS</button>
            {:else}
            <Button buttonClass={"btn-primary"} buttonText={"Select"} bind:isLoading={isButtonLoading} on:click="{()=> dispatch("select")}"/>
            <!-- <button class="btn btn-primary" on:click="{()=> dispatch("select")}">Select</button> -->
            {/if}
        </div>
    </div>
</div>